// @flow

import type {Node} from 'react';

import {PostHogProvider} from 'posthog-js/react';

export const PosthogInit = ({children}): Node => {
  if (process.env.PORTAL_SHORT !== 'aidu-at') {
    return <>{children}</>;
  }
  const options = {
    api_host: process.env.POSTHOG_HOST || 'https://eu.i.posthog.com',
    ui_host: 'https://eu.i.posthog.com',
    disable_web_experiments: process.env.STAGE !== 'qa',
    person_profiles: 'always',
    defaults: '2025-07-15',
  };
  return (
    <PostHogProvider apiKey={process.env.POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  );
};
